import { ShieldAlert, Upload } from "lucide-react";
import SgkBulkUpload from "../SgkBulkUpload";
import LocTemplateTools from "./LocTemplateTools";
import LocExcelUpload from "./LocExcelUpload";

// Şubeler sekmesi "Excel İşlemleri": standart / özel şablon · SGK eksik · Excel'den yükle (önizleme + onay)
export default function LocToolsPanel({ projectId, missingSgk, onSaved }) {
  return (
    <div className="bg-emerald-50/40 border border-emerald-200 rounded-md p-3 space-y-3" data-testid="loc-tools">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <LocTemplateTools projectId={projectId} />
        <div className="space-y-1.5" data-testid="loc-tools-sgk">
          <div className={`text-[10px] font-bold uppercase tracking-wider inline-flex items-center gap-1 ${missingSgk ? "text-red-800" : "text-slate-500"}`}><ShieldAlert className="w-3.5 h-3.5" /> SGK İşyeri No{missingSgk ? ` — ${missingSgk} şubede eksik` : ""}</div>
          {missingSgk ? <SgkBulkUpload projectId={projectId} missingCount={missingSgk} onSaved={onSaved} compact /> : <div className="text-[11px] text-slate-500 inline-flex items-center gap-1"><Upload className="w-3 h-3" /> Tüm şubelerde SGK işyeri no dolu — yükleme gerekmez.</div>}
        </div>
      </div>
      <div className="border-t border-emerald-200 pt-3">
        <LocExcelUpload projectId={projectId} onSaved={onSaved} />
      </div>
    </div>
  );
}
